import FlexRow from "../../FlexRow.vue";
import FilterSectionTitle from "./FilterSectionTitle.vue";
export default {
  name: "ActionsSection",
  components: {
    FlexRow,
    FilterSectionTitle
  },
  emits: ["discard", "apply", "closeDropdown"],
  props: {
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    changes: {
      type: [Object, String],
      default: null
    },
    // Filter-type label (sellers, marketplaces…) appended to the reset message.
    name: {
      type: String,
      default: ""
    }
  },
  computed: {
    isObject() {
      return typeof this.changes === "object" && this.changes !== null;
    },
    title() {
      // Object -> "changes recorded" (with count). String -> reset message,
      // to which we append the filter name.
      return this.isObject ? this.changes.text : `${this.changes ?? ""} ${this.name}`;
    }
  }
};